<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-toc" id="table-of-contents">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-introduction has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/introduction"><span class="element-title-text">Introduction</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/todayistoday"><span class="element-title-text">Today Is Today</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/rambunctious"><span class="element-title-text">Rambunctious</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/icecoversthehole" title="Link target outside of Sample"><span class="element-title-text">Ice Covers the Hole</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/walkingtoboston" title="Link target outside of Sample"><span class="element-title-text">Walking to Boston</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/somethingreal" title="Link target outside of Sample"><span class="element-title-text">Something Real</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/severalitemsofinterest" title="Link target outside of Sample"><span class="element-title-text">Several Items of Interest</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/hopeasanelementofcolddarkmatter" title="Link target outside of Sample"><span class="element-title-text">Hope as an Element of Cold, Dark Matter</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/prices" title="Link target outside of Sample"><span class="element-title-text">Prices</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/warbride" title="Link target outside of Sample"><span class="element-title-text">War Bride</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="element-title-text">About the Author</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/ifyouliked" title="Link target outside of Sample"><span class="element-title-text">If You Liked …</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/otherwordfirepresstitlesbyrickwilber" title="Link target outside of Sample"><span class="element-title-text">Other WordFire Press Titles by Rick Wilber</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?403b08e4